module.exports = __webpack_public_path__ + "img/empty.75998480.svg";